export default __webpack_public_path__ + "static/media/ic-present.6678df9c.svg";